/** Alerta de botón EU visible en la web solo si tiene sitio vinculado (site_id > 0). */
export function isValidLinkedSiteId(siteId: unknown): siteId is number {
  if (siteId == null || siteId === '') return false;
  const n = Number(siteId);
  return Number.isFinite(n) && n > 0;
}

export function isPendingButtonAlertSiteLinked(row: { siteId?: number | null }): boolean {
  return isValidLinkedSiteId(row.siteId);
}

export function isNotificationPayloadSiteLinked(payload: { siteId?: number | null }): boolean {
  return isValidLinkedSiteId(payload.siteId);
}

/** Toda alerta de mapa en la UI exige sitio vinculado (campana, panel, popup, pulso en mapa). */
export function shouldShowMapNotificationOnWeb(payload: {
  siteId?: number | null;
  scope?: string;
  mapNotificationId?: number | null;
}): boolean {
  if (payload.scope === 'map' || payload.mapNotificationId != null) {
    return isNotificationPayloadSiteLinked(payload);
  }
  return true;
}
